/*
 * @Author: Claude
 * @Date: 2025-11-11
 * @Description: Image to Video Store
 */

import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { createWithEqualityFn } from 'zustand/traditional';

import baseConfig from '@/config';

const key = 'f_image_to_video_state';

type ImageToVideoState = {
  formValues: {
    [key: string]: any;
  };
  setFormValues: (values: Partial<ImageToVideoState['formValues']>) => void;
  reset: () => void;
  setExtraData: (data?: Record<string, any>) => void;
  extraData?: Record<string, any>;
};

const initialData: ImageToVideoState['formValues'] = {
  modelID: 16,
};

export const useImageToVideoStore = createWithEqualityFn<ImageToVideoState>()(
  devtools(
    persist(
      (set) => ({
        formValues: initialData,
        setFormValues: (values: Partial<ImageToVideoState['formValues']>) =>
          set(() => ({ formValues: values })),
        reset: () => {
          set({ formValues: { ...initialData } });
        },
        setExtraData: (data?: Record<string, any>) => set(() => ({ extraData: data })),
      }),
      {
        name: key,
        storage: createJSONStorage(() => localStorage),
        partialize: ({ formValues }) => {
          const { image, last_image, aspect_ratio, ...rest } = formValues;
          return {
            formValues: rest,
          };
        },
      },
    ),
    {
      name: key,
      enabled: baseConfig.debuggable,
    },
  ),
);
